/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module AppdiscoveryTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Appdiscoveryplugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "AppActionNotificationReturn".
 */
export interface AppActionNotificationReturn {
    /**
     * Name of the application for which this notification is for
     */
    appName: string;
    action: Action;
    actionStatus: ActionStatusEnum;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "InstallAppParameters".
 */
export interface InstallAppParameters {
    /**
     * Name of an application to install.
     */
    name: string;
    /**
     * Full path to an EXE file which starts an installation
     */
    exePath: string;
    /**
     * Registry path installer writes after successful installation. Used to verify successful installation
     */
    registryPath: string;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "InstallAppReturn".
 */
export interface InstallAppReturn {
    executionStatus: ExeLaunchStatusEnum;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "UninstallAppParameters".
 */
export interface UninstallAppParameters {
    /**
     * Name of an application to Uninstall.
     */
    name: string;
    /**
     * Gives path to registry key which has command for unistallation for an app.
     */
    registryPath: string;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "UninstallAppReturn".
 */
export interface UninstallAppReturn {
    executionStatus: ExeLaunchStatusEnum;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "GetAppStatusParameters".
 */
export interface GetAppStatusParameters {
    /**
     * Name of an application
     */
    name: string;
    /**
     * Path to registry key to read installed version
     */
    registryPath: string;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "GetAppStatusReturn".
 */
export interface GetAppStatusReturn {
    status: Status;
    version?: string;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "GetAppsStatusParameters".
 */
export interface GetAppsStatusParameters {
    apps: {
        /**
         * Name of an application
         */
        name: string;
        /**
         * Gives path to registry key which is used to get installed version
         */
        registryPath: string;
    }[];
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "GetAppsStatusReturn".
 */
export interface GetAppsStatusReturn {
    apps?: {
        name: string;
        status: Status;
        version?: string;
    }[];
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "LaunchAppParameters".
 */
export interface LaunchAppParameters {
    /**
     * Name of an application
     */
    name: string;
    /**
     * Full path to EXE file to launch an app
     */
    exePath: string;
    /**
     * Path to registry key which has full path to an EXE file to launch an app
     */
    registryPath: string;
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "LaunchAppReturn".
 */
export interface LaunchAppReturn {
    launchStatus: ExeLaunchStatusEnum;
}

/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "ActionStatusEnum".
 */
export enum ActionStatusEnum {
    ActionStarted = 0,
    ActionRunning = 1,
    ActionSuccess = 2,
    ActionFailure = 3,
    ActionUnknown = 4
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "ExeLaunchStatusEnum".
 */
export enum ExeLaunchStatusEnum {
    Success = 0,
    Failure = 1,
    Unknown = 2
}
/**
 * This interface was referenced by `Appdiscoveryplugin`'s JSON-Schema
 * via the `definition` "Status".
 */
export enum Status {
    NotInstalled = 0,
    Installed = 1,
    Installing = 2,
    Uninstalling = 3,
    PartiallyInstalled = 4
}
export enum Action {
    Install = 0,
    Uninstall = 1
}


}
